module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq615-9506914c6bad8749b0d927b86963229d.jpg";